module.exports = "/fonts/fa-brands-400.woff2?7559b3774a0625e8ca6c0160f8f6cfd8";